module.exports = __webpack_public_path__ + "static/media/Kali-dragon-icon.svg.94fb172d.png";